import React from 'react';
import { connect } from 'react-redux';
import BreakDownChartContainer from 'components/pages/stats/occupancybreakdown/breakdownchartcontainer';
import { getStatsBreakdown, getParams } from 'actions/stats';
import ModeSelector from 'components/common/dropdowncomponents/modeselector';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import MultiSelect from './multiselect';
//import Modal from "components/common/modal";
export class OccupancyBreakDown extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isArea: false,
            mode: "Average",
            areas: []
        };
    }

    chooseMode(mode) {
        this.setState({ mode: mode });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentNode.id) {
            if (nextProps.currentNode.type == "meeting_room" || nextProps.currentNode.type == "open_area") {
                this.setState({ isArea: true });
            } else {
                let params = getParams(nextProps);
                params.id = [];
                // params.areas = new Map();
                params.areaOptions = [];
                this.getAreaChildren(nextProps.currentNode, params.id, params.areaOptions);
                this.setState({
                    isArea: false,
                    areaOptions: params.areaOptions
                }, () => {
                    if (nextProps.querySettings.tag == "Efficiency") {
                        this.chooseMode("Average");
                    }
                });
                this.props.dispatch(getStatsBreakdown(params));
            }
        }
    }

    getAreaChildren(tree, ids, areaOptions) {
        var self = this;
        tree.children.forEach((node) => {
            if (node.type == 'meeting_room' || node.type == 'open_area') {
                ids.push(node.id);
                // areas.set(node.id, node.info.name + "\n" + node.children.length + " desks");
                areaOptions.push({ value: node.id, label: node.info.name, length: node.children.length, selected: false });
            } else {
                self.getAreaChildren(node, ids, areaOptions);
            }
        });
    }

    handleSelectChange(value) {
        var areaOptions = this.state.areaOptions.slice();
        var index = areaOptions.indexOf(value);

        areaOptions[index].selected = !areaOptions[index].selected;

        var areas = [];
        var count = 0;
        for (var i = 0; i < areaOptions.length; i++) {
            if (areaOptions[i].selected) {
                count++;
                areas.push({ id: areaOptions[i].value, label: areaOptions[i].label + "\n(" + areaOptions[i].length + " desks)" });
            }
        }
        var displayValue;
        switch (count) {
            case 0:
                displayValue = "No room selected.";
                break;
            case 1:
                displayValue = "1 room selected.";
                break;
            default:
                displayValue = count + " rooms selected.";
        }
        this.setState({
            areas: areas,
            value: value,
            areaOptions: areaOptions,
            displayValue: displayValue
        });
    }

    clearSelect() {
        var areaOptions = this.state.areaOptions.slice()
        for (var i = 0; i < areaOptions.length; i++) {
            areaOptions[i].selected = false;
        }

        this.setState({
            areas: [],
            areaOptions: areaOptions,
            value: 0,
            displayValue: "No room selected."
        });
    }

    render() {
        return (
            <React.Fragment>
                {!this.state.isArea &&
                    <div className="stats-card">
                        <div className="box--shadow bg--white card__graph" ref={(e) => { document.charts.occupancyBreakDown = e }} >
                            <div className="clearfix graph__header">
                                <div className="graph__header__options pull-right clearfix">
                                    <div
                                        style={{
                                            marginLeft: "45px"
                                        }}
                                        className="header__options__child pull-left">
                                        {
                                            (this.props.querySettings.tag != "Efficiency") ?
                                                <ModeSelector mode={this.state.mode} chooseMode={this.chooseMode.bind(this)} />
                                                :
                                                <Dropdown className="no--cursor--pointer" noArrow={true} header={this.state.mode} toggleable={false} />
                                        }
                                    </div>

                                    <div className="header__options__child breakdown-chart-select pull-left">
                                        <div data-tooltip="Open for more details">
                                            <MultiSelect
                                                onChange={(value) => { this.handleSelectChange(value) }}
                                                onFocus={() => { }}
                                                onClose={() => { }}

                                                options={this.state.areaOptions}
                                                displayValue={this.state.displayValue}
                                                value={this.state.value}
                                            />
                                        </div>
                                    </div>
                                    <div className="header__options__child multi--select--clear pull-left">
                                        <i className="material-icons multi-select-clear" onClick={() => { this.clearSelect() }} data-tooltip="Clear all">clear</i>
                                    </div>
                                    {/*
                                    <Modal
                                        disableCloseButton={true}
                                        ref={(elem) => { this.openInfoModal = elem }}
                                        clickButton={() => { this.openInfoModal.close(); }}
                                        header="Info Modal"
                                        buttonText="Got it"
                                        buttonClass="btn-success"
                                        entry={
                                            <div className="header__options__child pull-left">
                                                <div onClick={() => { this.openInfoModal.open() }}>
                                                    <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                                </div>
                                            </div>
                                        }
                                    >
                                        <p>Breakdown Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    </Modal>
                                 */}
                                </div>
                                <div className="graph__header__title pull-right">
                                    <h2 >{this.props.querySettings.tag} Breakdown</h2>
                                </div>
                            </div>

                            <div className="graph__body">
                                <BreakDownChartContainer mode={this.state.mode} areas={this.state.areas} />
                            </div>
                        </div>
                    </div>
                }

            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(OccupancyBreakDown);



// WEBPACK FOOTER //
// ./src/components/pages/stats/occupancybreakdown/index.jsx